module.exports = __webpack_public_path__ + "img/ExclusiveWorkshop.70800372.png";